var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebDevIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_540",
    "data-name": "Group 540",
    transform: "translate(-197 -790)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    transform: "translate(197 790)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-code",
    "data-name": "Icon awesome-code",
    d: "M9.586,17.583l-2.1-.608a.413.413,0,0,1-.282-.512L11.9.3a.413.413,0,0,1,.512-.282l2.1.608a.413.413,0,0,1,.282.512L10.1,17.3A.412.412,0,0,1,9.586,17.583ZM5.667,13.726l1.5-1.595a.412.412,0,0,0-.027-.591L4.021,8.8,7.135,6.061a.41.41,0,0,0,.027-.591l-1.5-1.595a.413.413,0,0,0-.584-.017L.13,8.5a.41.41,0,0,0,0,.6l4.953,4.644a.41.41,0,0,0,.584-.017Zm11.247.021L21.867,9.1a.41.41,0,0,0,0-.6L16.914,3.854a.416.416,0,0,0-.584.017l-1.5,1.595a.412.412,0,0,0,.027.591L17.976,8.8,14.862,11.54a.41.41,0,0,0-.027.591l1.5,1.595a.413.413,0,0,0,.584.021Z",
    transform: "translate(201.002 796.699)",
    fill: "#8f6f6f"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDevIcon);
export default __webpack_public_path__ + "static/media/webDevIcon.4012452c89525e2df1deaaf20ac55c8b.svg";
export { ForwardRef as ReactComponent };